
export default {
  expensesdashboard: [],
  addressdelivery:[],
  addressbilling:[],
  productlistpdf:[],
  invoiceattached: [],
  invoiceattach: [],
  operations: [],
  operation: [],
  operationproducts: [],
  m3difference:null,
  rondifference:null,
  eurdifference:null,
  peoplelist:[],
  expenses: [],
  expense: [],
  expenselines: [],
}
 